module.exports = __webpack_public_path__ + "static/media/themesong.b3998377.mp3";